module.exports = __webpack_public_path__ + "img/cytp-active.32b34f2e.svg";